import React from "react";
import PageShell from "../components/PageShell";
import { SecretGreeting } from "../components/EasterEggs";

export default function SecretPage() {
  return (
    <PageShell>
      <section className="pt-32 md:pt-40 pb-24 md:pb-32" data-testid="secret-page">
        <SecretGreeting />
      </section>
    </PageShell>
  );
}
